import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import Button from 'src/component/UI/Button';
import DeviceSelectorField from 'src/component/UI/DeviceSelectorField';
import { useTranslation } from 'src/i18n';

export default function LinkDeviceDialog (props) {
  const { open, onClose, onConfirm, deviceType } = props;
  const { t } = useTranslation();
  const [selectedDevice, setSelectedDevice] = useState(null);

  const handleConfirm = () => {
    if (selectedDevice && selectedDevice.id) {
      onConfirm(selectedDevice.id);
      setSelectedDevice(null);
    }
  };

  const handleClose = () => {
    setSelectedDevice(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <h2>{t('commissioning.linkDevice')}</h2>
      <div>
        <DeviceSelectorField
          type={deviceType}
          onChange={setSelectedDevice}
          value={selectedDevice}
        />
      </div>
      <div className='button-bar'>
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
        <Button cta onClick={handleConfirm} disabled={!selectedDevice || !selectedDevice.id}>
          {t('commissioning.linkDevice')}
        </Button>
      </div>
    </Dialog>
  );
}

LinkDeviceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  deviceType: PropTypes.oneOf(['commLoop', 'circuit', 'controller', 'circuitsAndCommLoops'])
};
